/** @deprecated use AvgRoutesEnum from libs */
export enum AvgRoutesEnum {
    Rights = 'rechten',
    Thanks = 'bedankt',
    Identification = 'identificatie',
}
